import React from "react";
import { Field, useFormState } from "react-final-form";

import { NavigationButton } from "../components/NavigationButton";
import { ConditionGrades } from "../types/apis";
import { FormData, FormResources } from "../types/formData";
import { Navigation } from "../types/navigation";
import { DescriptionBox, RadioButtonsContainer } from "../valuation-manager.styles";

interface ConditionsPageProps {
  setPageName: (pageName: Navigation) => void;
  formResources: FormResources;
}

export const ConditionsPage: React.FC<ConditionsPageProps> = ({
  setPageName,
  formResources,
}: ConditionsPageProps) => {
  const { values }: { values: FormData } = useFormState();

  const selectedCondition = formResources.conditions.options.find(
    (condition) =>
      condition.value === (values.condition || ConditionGrades.Excellent),
  );

  return (
    <div>
      <div className="row">
        <RadioButtonsContainer>
          <legend className="col-sm-12 col-md-12 col-lg-12">
            {formResources.conditions.title}
          </legend>
          <div className="col-sm-4 col-md-4 col-lg-4">
            {formResources.conditions.options.map((option) => (
              <div className="radio" key={option.value}>
                <label>
                  <Field
                    name="condition"
                    component="input"
                    type="radio"
                    value={option.value}
                    required
                    aria-label={`${option.label} Condition`}
                  />
                  {option.label}
                </label>
              </div>
            ))}
          </div>
          <DescriptionBox className="col-sm-8 col-md-8 col-lg-8">
            <div className="well well-lg">
              <p>{selectedCondition?.title}</p>
              <p>{selectedCondition?.body}</p>
            </div>
          </DescriptionBox>
        </RadioButtonsContainer>
      </div>
      <NavigationButton setPageName={setPageName} disabled={!values.condition} />
    </div>
  );
};
